export const featureFlags = {
  MODULE_MANUAL_CREATION: 'module-manual-creation',
  BITE_MANUAL_CREATION: 'bite-manual-creation'
}
